import { Constants } from '.'

export const getProfile = () => ({
  type: Constants.PROFILE_GET
})

export const getSuccess = payload => ({
  type: Constants.PROFILE_GET_SUCCESS,
  payload
})

export const getFailure = error => ({
  type: Constants.PROFILE_GET_FAILURE,
  error
})
